import BaseTabSchema from 'root-packages/tabSchemaValidation/baseTabSchema.js'
import * as validations from '../../../validations.js'
import format from 'root-core/utils/text/stringFormatFilter.js'

class FrequentTravellerDiscountSchema extends BaseTabSchema {
  constructor (options) {
    super(options)
    this.config = options.config
  }

  validateFTD () {
    return validations.ensure(
      format(this.config.errorMessages.frequentTravellerDiscount, this.config.brandFamilyDisplayText),
      (value, is, object) => {
        return (
          value === false ||
          object.passengers.some(p => p.frequentTravellerDiscount.selected)
        )
      }
    )
  }

  buildSchema () {
    return {
      passengers: [
        {
          frequentTravellerDiscount: {
            tourName: this.ftdTourName(),
            tourDateMonth: this.ftdTourMonthSelected(),
            tourDateYear: this.ftdTourYearSelected(),
          },
        },
      ],
      frequentTravellerDiscount: this.validateFTD(),
    }
  }
}

export default FrequentTravellerDiscountSchema